export const EMPTY_STREAMING_CONFIG = {
    serialiStreaming: [],
    streamingH265: [],
    streamingH264: [],
    streamingDrone: [],
    streamingBarca: [],
    streamingSenzaSeqMission: [],
};

export function normalizeStreamingConfig(data) {
    if (!data || typeof data !== 'object') {
        return { ...EMPTY_STREAMING_CONFIG };
    }

    return {
        serialiStreaming: Array.isArray(data.serialiStreaming) ? data.serialiStreaming : [],
        streamingH265: Array.isArray(data.streamingH265) ? data.streamingH265 : [],
        streamingH264: Array.isArray(data.streamingH264) ? data.streamingH264 : [],
        streamingDrone: Array.isArray(data.streamingDrone) ? data.streamingDrone : [],
        streamingBarca: Array.isArray(data.streamingBarca) ? data.streamingBarca : [],
        streamingSenzaSeqMission: Array.isArray(data.streamingSenzaSeqMission) ? data.streamingSenzaSeqMission : [],
    };
}

export function createStreamingConfigFromProps(props = {}) {
    return normalizeStreamingConfig({
        serialiStreaming: props.serialiStreaming,
        streamingH265: props.streamingH265,
        streamingH264: props.streamingH264,
        streamingDrone: props.streamingDrone,
        streamingBarca: props.streamingBarca,
        streamingSenzaSeqMission: props.streamingSenzaSeqMission,
    });
}
